<template>
  <div class="game-description-bg" :class="bg">
    <top-navigation>
      <div slot="right" class="logo" v-if="showPhotoArk">
        <img src="../assets/img/ngkids-photo_ark.png">
      </div>
    </top-navigation>
    <div class="content-wrapper">
      <div class="content">
        <h1>{{ title }}</h1>
        <p>{{ description }}</p>
        <button class="btn btn-primary mx-auto ng-default-btn mx-auto next-btn" @click="start()">NEXT</button>
      </div>
    </div>
    <div v-if="showLogo" class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-4">
        </div>
        <div class="col-4 loading-text-wrapper">
        </div>
        <div class="col-4 logo">
          <img src="../assets/img/logo.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavigation from './TopNavigation'
import screenfull from 'screenfull'
import { mapMutations } from 'vuex'
export default {
  components: {
    TopNavigation
  },
  props: {
    title: String,
    description: String,
    bg: {
      type: String,
      default: 'default'
    },
    showLogo: {
      type: Boolean,
      default: true
    },
    showPhotoArk: {
      default: false
    }
  },
  methods: {
    ...mapMutations(['setCardDiff', 'setLastGameScore']),
    start () {
      if (screenfull.enabled && window.isMobile) {
        // screenfull.request()
      }
      this.setCardDiff()
      this.setLastGameScore(0)
      this.$emit('start')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .game-description-bg {
    width: 100%;
    background-size: cover;
    background-position: center;
    height: 100%;
  }

  .game-description-bg.default {
    background-image: url("../assets/img/gameDescription.jpg");
  }

  .game-description-bg.now-you-see-me {
    background-image: url("../assets/img/now-you-see-me-description-bg.jpg");
  }

  .content h1 {
    font-family: "Geograph-Bold";
    color: #feca33;
    font-size: 10vh;
    padding-bottom: 6vh;
    text-align: center;
    text-shadow: 0px 3px 2px rgba(0, 0, 0, 0.8);
  }

  .content-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 75vh;
  }

  .content {
    text-align: center;
    max-width: 90%;
    color: #ffffff;
  }

  .content p {
    font-size: 8vh;
    padding-bottom: 6vh;
    text-align: center;
    font-family: "Geograph-Black";
    text-transform: uppercase;
    text-shadow: 0px 3px 2px rgba(0, 0, 0, 0.8);
  }
</style>
